export const getCustomBlocksGroupSelector = (state) => {
  return state.blocks.customBlockCategories;
};
